import { of as observableOf, Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';

/**
 * A Router module pre-loading strategy that loads all lazy modules that are not share gain app's modules.
 * This strategy is identical to PreloadAllModules, the only difference is that it will exclude lazy share gain app
 * modules. To qualify as a sharegain lazy app module the Route must include a data object with the property "sgAppName"
 * set to the name of the app.
 */
@Injectable()
export class SgModulePreloadingStrategy implements PreloadingStrategy {
  preloadedModules: string[] = [];

  constructor() {}

  preload(route: Route, load: () => Observable<any>): Observable<any> {
    if (route.data && route.data.sgAppName) {
      return observableOf(null);
    } else {
      this.preloadedModules.push(route.path);
      return load();
    }
  }
}
